module.exports = __webpack_public_path__ + "brand-img.png?8b176b0a77abcbac1be699f3793a2d8e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brand-img.png
// module id = 26
// module chunks = 0